<template>
  <tm-custom-tooltip
    :anchor-element="anchorElement"
    :color="color"
    :offset="offset"
    :direction="direction"
    :interactive="interactive"
    :disabled="disabled"
    :delay="delay"
    :persistence="persistence"
  >
    <div v-if="typeof keypath === 'string'">{{ $t(keypath) }}</div>
    <tm-translate
      v-else
      :keypath="keypath.translateKey"
    >
      <template
        v-for="slot in keypath.slots"
        :key="slot.name"
        v-slot:[slot.name]
      >
        <a
          v-if="slot.href && openLinkOnMousedown"
          target="_blank"
          :href="slot.href"
          @mousedown.stop.prevent="openLink(slot.href)"
        >
          {{ slot.value }}
        </a>
        <a
          v-else-if="slot.href"
          target="_blank"
          :href="slot.href"
        >
          {{ slot.value }}
        </a>
        <span
          v-else
          class="body-text-semi-bold-14 white--text"
        >
          {{ slot.value }}
        </span>
      </template>
    </tm-translate>
  </tm-custom-tooltip>
</template>

<script setup lang="ts">
import type { TmTranslateTooltipPropsType } from '@/components/shared/tooltip/types'
import TmCustomTooltip from '@/components/shared/tooltip/TmCustomTooltip.vue'
import TmTranslate from '@/components/TmTranslate.vue'
import { getWindowService } from '@/core/container/ioc'

const { keypath = '', openLinkOnMousedown = false, delay } = defineProps<TmTranslateTooltipPropsType>()

const openLink = (href: string) => {
  getWindowService().open(href, '_blank')
}
</script>
